<template>
  <div class="add-feedback-container" style="">
    <el-card class="add-feedback-card">
      <el-form :model="form" label-width="160px"  >
        <el-form-item label="学生" prop="student">
          <el-input v-model="form.student" disabled></el-input>
        </el-form-item>
        <el-form-item label="年级" prop="grade">
          <el-input v-model="form.grade" disabled></el-input>
        </el-form-item>
        <el-form-item label="学科" prop="subject">
          <!-- <el-select v-model="form.subject" placeholder="请选择学科" style="width: 100%;" filterable clearable>
            <el-option
              v-for="item in subjects"
              :key="item.categoryId"
              :label="item.categoryName"
              :value="item.categoryId">
            </el-option>
          </el-select> -->
          <el-input v-model="form.subject" disabled></el-input>
        </el-form-item>
        <el-form-item label="老师" prop="teacher">
          <!-- <el-select v-model="form.teacher" placeholder="请选择老师" style="width: 100%;" filterable clearable>
            <el-option
              v-for="item in teachers"
              :key="item.teacherId"
              :label="item.teacherName"
              :value="item.teacherId">
            </el-option>
          </el-select> -->
          <el-input v-model="form.teacher" disabled></el-input>
        </el-form-item>

<!-- 
        <el-form-item >
          <div style="text-align: center;">对校区展示（事实）</div>
          <el-divider></el-divider>
        </el-form-item> -->



        <el-form-item label="学科能力分析" prop="homeworkCompletion">
          <el-input v-model="form.homeworkCompletion"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder=""
          :disabled="showpopLongtitle === '查看'"
          ></el-input>
        </el-form-item>

        <el-form-item label="学习习惯与性格特点" prop="recentExam">
          <el-input v-model="form.recentExam"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          :disabled="showpopLongtitle === '查看'"
          maxlength="9999999"
          placeholder=""></el-input>
        </el-form-item>

        <el-form-item label="后续学习计划" prop="classAbsorption">
          <el-input v-model="form.classAbsorption"
          type="textarea"
          :disabled="showpopLongtitle === '查看'"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder=""></el-input>
        </el-form-item>

        <!-- <el-form-item label="该学科是否有流失风险" prop="categoryLeaveCondition">
          <el-input v-model="form.categoryLeaveCondition"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="是或否，及原因"></el-input>
        </el-form-item>


        <el-form-item >
          <div style="text-align: center;">对家长展示（委婉）</div>
          <el-divider></el-divider>
        </el-form-item>


        <el-form-item label="校园表现情况" prop="campusPerformance">
          <el-input v-model="form.campusPerformance"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="1.同学关系，师生关系
2.被老师表扬的地方"></el-input>
        </el-form-item>




        <el-form-item label="精神面貌情况" prop="spiritualAppearance">
          <el-input v-model="form.spiritualAppearance"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="1.比上个月进步的地方"></el-input>
        </el-form-item>



        <el-form-item label="学科表现及学习建议" prop="categoryExpression">
          <el-input v-model="form.categoryExpression"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="1.该学科优点
2.该学科待提升的地方
3.该学科学习建议"></el-input>
        </el-form-item>

        <el-form-item label="学生进步情况" prop="studyProgressCondition">
          <el-input v-model="form.studyProgressCondition"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="1.学习习惯改善
2.作业完成质量
3.对学科兴趣的提升
4.成绩的进步
5.学习动力提升">
          </el-input>
        </el-form-item> -->





        <!-- <el-form-item label="创建人" prop="creator">
          <el-select v-model="form.creator" placeholder="请选择创建人" style="width: 100%;" filterable clearable>
            <el-option
              v-for="item in creators"
              :key="item.id"
              :label="item.realname"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="上传资料" prop="file" v-if="showpopLongtitle !== '查看'">
          <el-button size="small" type="primary" class="btns" @click="handleUpload">点击上传</el-button>
        </el-form-item> -->

        <!-- <el-form-item v-if="fileAllLists.length > 0">
          <el-col :span="5" v-for="(file, index) in fileAllLists" :key="index" style="margin-right: 10px;">
            <el-card style="margin-bottom: 10px;">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-tooltip  effect="light" :content="file.name" placement="top">
                    <p class="flashing-text two-lines" style="padding-left: 10px;font-weight: 900;height: 40px;">{{ file.name }}</p>
                  </el-tooltip>
                  <div style="display: flex; justify-content: space-between; top: -25px; margin-left: 77px; position: absolute;right: 0;">
                    <svg style="padding-top: 10px; margin: 0px 30px 0px 0px;"  @click="downloadFile(file.name,file.url)" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9999 29.0001L12 17.0001L19.9999 17.0001L19.9999 6.00011L27.9999 6.00011L27.9999 17.0001L35.9999 17.0001L23.9999 29.0001Z" fill="#43a8c9" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/><path d="M42 37L6 37" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                      <path d="M34 44H14" stroke="#1fa6fa" stroke-width="4" stroke-linecap="square"/>
                    </svg>
                     <svg style="padding-top: 10px;" @click="deletFile(2,offlineFileList,index)" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <path d="M8 11L40 11" stroke="#cf2424" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                       <path d="M18 5L30 5" stroke="#cf2424" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                       <path d="M12 17H36V40C36 41.6569 34.6569 43 33 43H15C13.3431 43 12 41.6569 12 40V17Z" fill="#cf2424" stroke="#cf2424" stroke-width="4" stroke-linejoin="bevel"/>
                       <path d="M20 25L28 33" stroke="#fff" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                       <path d="M28 25L20 33" stroke="#fff" stroke-width="4" stroke-linecap="square" stroke-linejoin="bevel"/>
                     </svg>
                   </div>
                </el-col>
              </el-row>
            </el-card>
           </el-col>
        </el-form-item> -->

      </el-form>
    </el-card>

    <div style="text-align: center;">
        <el-button size="small"  class="btns"  type="primary" @click="save" v-if="showpopLongtitle !== '查看'">保存</el-button>
        <el-button size="small"  class="btns"  type="primary" @click="cancel">返回</el-button>
    </div>

    <Elupload
      v-if="isShowElupload"
      @handleEventElUpload="handleEventElUpload"
      @handleEventElUploadSubt="handleEventElUploadSubt"
      :Uploadtypes="Uploadtypes"
      :fileAllLists="fileAllLists"
    ></Elupload>



  </div>
</template>

<script>
import { getSubject, } from "@/api/firstClassApi";
import Elupload from "./Elupload.vue";
import axios from "axios";
import apiBaseUrl from "../../config/api";
import loadingUtils from "../utils/loading";
export default {
  components: {
    Elupload,
  },
  props: {

    studentData: {
      type: Object,
      default: () =>{
        return {}
      }
    },

    showpopLongtitle: {
      type: String,
      default: ''
    },

    dataRow: {
      type: Object,
      default: () =>{
        return {}
      }

    },
  },
  data() {
    return {

      form: {
        student: '默认学生名字',
        grade: '默认学生年级',
        subject: '',
        teacher: '',
        homeworkCompletion: '',
        classAbsorption: '',
        campusPerformance: '',
        recentExam: '',
        spiritualAppearance: '',
        creator: '',
        categoryLeaveCondition: '',
        categoryExpression: '',
        studyProgressCondition: '',
      },

      subjects: [],
      teachers: [],
      creators: [],
      fileList: [],
      uploadUrl: 'http://localhost:3000/upload',
      isShowElupload:false,

      fileAllLists:[],

    };
  },

  mounted() {


    // this.getAllAxios()


    if(this.studentData && this.studentData.realname){
      this.form.student = this.studentData.realname ? this.studentData.realname : ''
      this.form.grade = this.studentData.gradeStr ? this.studentData.gradeStr : ''
    }


    console.log(this.dataRow , 'dataRow')

    if(this.dataRow && this.dataRow.id){
        this.form.id = this.dataRow.id ? this.dataRow.id : ''
        this.form.subject = this.dataRow.categoryId ? this.dataRow.categoryId : ''
        this.form.teacher = this.dataRow.teacherName ? this.dataRow.teacherName : ''
        this.form.homeworkCompletion = this.dataRow.taskCondition ? this.dataRow.taskCondition : ''
        this.form.classAbsorption = this.dataRow.classCondition ? this.dataRow.classCondition : ''
        this.form.campusPerformance = this.dataRow.campusExpression ? this.dataRow.campusExpression : ''
        this.form.recentExam = this.dataRow.examCondition ? this.dataRow.examCondition : ''
        this.form.spiritualAppearance = this.dataRow.spiritFace ? this.dataRow.spiritFace : ''
        this.fileAllLists = this.dataRow.dataUploading ? JSON.parse(this.dataRow.dataUploading) : []
        this.form.categoryLeaveCondition = this.dataRow.categoryLeaveCondition ? this.dataRow.categoryLeaveCondition : ''
        this.form.categoryExpression = this.dataRow.categoryExpression ? this.dataRow.categoryExpression : ''
        this.form.studyProgressCondition = this.dataRow.studyProgressCondition ? this.dataRow.studyProgressCondition : ''

        this.form.student = this.dataRow.studentName ? this.dataRow.studentName : ''
        this.form.grade = this.dataRow.gradeName ? this.dataRow.gradeName : ''
        this.form.subject = this.dataRow.subjectName ? this.dataRow.subjectName : ''

        this.form.homeworkCompletion  = this.dataRow.subjectAnalysis ? this.dataRow.subjectAnalysis : ''
        this.form.recentExam  = this.dataRow.habitTrait ? this.dataRow.habitTrait : ''
        this.form.classAbsorption  = this.dataRow.studyPlan ? this.dataRow.studyPlan : ''
        
    }

  },

  methods: {

    downloadFile(name,url) {

    loadingUtils.startLoading()

    fetch(url).then(response => response.blob()).then(blob => {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)

      setTimeout(() => {
        loadingUtils.endLoading()
        this.$message.success('文件下载成功~')
      }, 1000)

    })

    },

    getAllAxios() {

      axios.get(`${apiBaseUrl}/studentFeedback/getCategoryList`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.subjects = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })

      axios.get(`${apiBaseUrl}/studentFeedback/getTeacherList`, { headers: { authorization: sessionStorage.getItem("tokenInfo"),  },}).then((res) => {
         this.teachers = res.data.data
      }).catch((error) => {
         this.$message({ type: 'error', message: error })
      })


      // axios.get(`${apiBaseUrl}/schedule/teacherlist`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then((response) => {
      //       this.teachers = response.data.data
      // }).catch((error) => {
      //     this.$mesage.error(error)
      // })

      axios.get(`${apiBaseUrl}/questionnaire/queryCreator`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') },}).then(res => {
            this.creators = res.data.data
        }).catch(error => {
          this.$message.error(error)
      })

      // getSubject().then((res) => { this.subjects = res.data; })

    },

    deletFile(type,list,index){
      this.$confirm('确定要删除该文件吗？', '提示', {  confirmButtonText: '确定',  cancelButtonText: '取消',  type: 'warning' }).then(() => {
        if (type === 1) {
            this.fileAllLists.splice(index, 1)
        }
        if (type === 2) {
            this.fileAllLists.splice(index, 1)
        }
         this.$message({   type: 'success',   message: '删除成功!' })
      }).catch(() => {
         this.$message({  type: 'info',  message: '已取消删除'  });
      })
    },

    handleUpload(type) {
      this.Uploadtypes = type
      // this.fileAllLists = []

      this.isShowElupload = true
    },
    handleEventElUploadSubt(flileList) {
      this.isShowElupload = false;
      if (flileList && flileList.length > 0) {
         this.fileAllLists = [...this.fileAllLists,...flileList]
      }

    },
    handleEventElUpload(flileList) {
      this.isShowElupload = false;
    },
    handleSuccess(response, file, fileList) {
      console.log('上传成功:', response, file, fileList);
    },
    save() {
      // 保存逻辑
      console.log('保存:', this.form);

      let data = {
        // studentId: this.studentData.id,
        // categoryId: this.form.subject,
        // teacherId: this.form.teacher,
        // campusExpression: this.form.campusPerformance,
        // spiritFace: this.form.spiritualAppearance,
        // taskCondition: this.form.homeworkCompletion,
        // classCondition: this.form.classAbsorption,
        // examCondition: this.form.recentExam,
        // categoryLeaveCondition: this.form.categoryLeaveCondition,
        // categoryExpression: this.form.categoryExpression,
        // studyProgressCondition: this.form.studyProgressCondition,

        id: this.form.id ? this.form.id : '',
        dataUploading: this.fileAllLists ? JSON.stringify(this.fileAllLists) : '[]',
        habitTrait: this.form.recentExam,
        studyPlan: this.form.classAbsorption,
        subjectAnalysis: this.form.homeworkCompletion,
      }

      let url = 'firstFeedback/update'

      axios.post(`${apiBaseUrl}/${url}`, data, { headers: { authorization: sessionStorage.getItem("tokenInfo"),},}).then((res) => {
          if (res.data.code === 200){
              this.$message({ type: 'success', message: '添加成功!' })
              this.$emit('handlecancel');
          }else{
            this.$message({ type: 'error', message: '添加失败!' })
          }
        }).catch((error) => {
          this.$message({ type: 'error', message: error })
     })

    },
    cancel() {
      // 返回逻辑
      console.log('取消');
      this.$emit('handlecancel');
    }
  }
};
</script>

<style scoped>

.on-click{
  pointer-events: none;
}
.add-feedback-container {
  padding: 20px;
}
.add-feedback-card {
  margin-bottom: 20px;
}
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}
.btns {
  background-color: #428bca;
  border-color: #428bca;
  color: #fff;
}


@keyframes flash {
  0% {
    opacity: 1;
    color: rgb(22, 145, 221);
  }
  14.2857% {
    opacity: 1;
    color: rgb(132, 29, 236);
  }
  28.5714% {
    opacity: 1;
    color: rgb(19, 205, 162);
  }
  42.8571% {
    opacity: 1;
    color: rgb(236, 28, 87);
  }
  57.1428% {
    opacity: 1;
    color: rgb(88, 200, 14);
  }
  71.4285% {
    opacity: 1;
    color: rgb(135, 172, 111);
  }
  85.7142% {
    opacity: 1;
    color: rgb(19, 205, 162);
  }
  100% {
    opacity: 1;
    color: rgb(236, 28, 87);
  }
}

.flashing-text {
  animation: flash 10s infinite alternate;
}

.two-lines {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/SummaryAafterFirstClass/showpopLong.vue